import styled from 'styled-components';
import { HealtheraButton } from '../../../../../../healtheraComponents';
import Note from '../../../../../Notes/Note';
import Spinner from '../../../../../Shared/Spinner';

const NotesListComponent = ({ isFetching, notes, handleAddNote }) => (
  <Container>
    <NotesContainer>
      {isFetching ? (
        <Spinner />
      ) : (notes ? (
        notes?.map?.((note) => (
        <NoteWrapper key={note._id}>
          <Note note={note} withPadding />
        </NoteWrapper>
      ))) : null)}
    </NotesContainer>
    <ButtonContainer>
      <HealtheraButton
        height="35px"
        width="285px"
        onClick={handleAddNote}
      >
        Add note
      </HealtheraButton>
    </ButtonContainer>
  </Container>
);

const Container = styled.div`
  position: relative;
  box-sizing: border-box;
  background: #fff;
`;

const NotesContainer = styled.div`
  padding: 16px 24px;
  padding-bottom: 60px;
  overflow-y: auto;
  max-height: 650px;
  width: 660px;
`;

const NoteWrapper = styled.div`
  margin-bottom: 16px;
`;

const ButtonContainer = styled.p`
  position: absolute;
  bottom: 4px;
  margin: 0;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export default NotesListComponent;
